
export const GeographicalType = {
    StateProvince: 'State/Province',
    Station: 'Station',
    Region: 'Region',
    Subregion: 'Subregion',
    Country: 'Country'
} as const;

export type GeographicalType = typeof GeographicalType[keyof typeof GeographicalType];

export const GeographicalTypes: GeographicalType[] = [
    GeographicalType.Country,
    GeographicalType.Region,
    GeographicalType.Subregion,
    GeographicalType.StateProvince,
    GeographicalType.Station
];
